import React from 'react';
import Home from './sections/Home';
import About from './sections/About';
import CvCertificates from './sections/CvCertificates';
import Skills from './sections/Skills';
import Portfolio from './sections/Portfolio';
import Contact from './sections/Contact';
function App() {
  return (
    <div className="bg-white text-gray-800 font-sans">
      <Home />
      <About />
      <CvCertificates />
      <Skills />
      <Portfolio />
      <Contact />
    </div>
  );
}

export default App;
